import { render, staticRenderFns } from "./PackageCard.vue?vue&type=template&id=52a711da&scoped=true"
import script from "./PackageCard.vue?vue&type=script&lang=ts"
export * from "./PackageCard.vue?vue&type=script&lang=ts"
import style0 from "./PackageCard.vue?vue&type=style&index=0&id=52a711da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a711da",
  null
  
)

export default component.exports